import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
} from '../../types';
import { timePeriodUnsegmentedBarChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  TimePeriodUnsegmentedBarChartActions,
  TimePeriodUnsegmentedBarChartState,
  TimePeriodUnsegmentedBarChartUiComponentProps,
} from './types';
import { TimePeriodUnsegmentedBarChartUiComponent } from './UiComponent';
import { useTimePeriodUnsegmentedBarChartStateManager } from './useStateManager';

export const timePeriodUnsegmentedBarChartViewConfig: DataVizContainerViewConfigWithStateManager<
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
  TimePeriodUnsegmentedBarChartUiComponentProps,
  TimePeriodUnsegmentedBarChartState,
  TimePeriodUnsegmentedBarChartActions
> = {
  hasStateManager: true,
  useStateManager: useTimePeriodUnsegmentedBarChartStateManager,
  dataToUiComponentProps: timePeriodUnsegmentedBarChartDataToUiComponentProps,
  UiComponent: TimePeriodUnsegmentedBarChartUiComponent,
};
